import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfilter',
  pure: true,
  standalone: false,
})
export class SearchfilterPipe implements PipeTransform {
  transform(value: any[], keys: string, term: string): any[] {
    if (!term || !value) return value; // Se non c'è il termine, restituisci l'intera lista

    term = term.toLowerCase(); // Confronto case-insensitive

    return value.filter((item) => {
      return keys.split(',').some((key) => {
        // Ottieni il valore della chiave (supporta chiavi annidate)
        const property = this.getNestedValue(item, key);

        // Se è un array, cerca all'interno degli oggetti nell'array
        if (Array.isArray(property)) {
          return property.some(
            (subItem) =>
              typeof subItem === 'string'
                ? subItem.toLowerCase().includes(term) // Stringa semplice
                : this.containsTermInObject(subItem, term) // Oggetto complesso
          );
        }

        // Se è una stringa, cerca il termine nella stringa
        if (typeof property === 'string') {
          return property.toLowerCase().includes(term);
        }

        return false;
      });
    });
  }

  // Ottieni un valore da chiavi annidate come 'containers.name'
  private getNestedValue(item: any, key: string): any {
    return key
      .split('.')
      .reduce((obj, keyPart) => (obj && obj[keyPart] !== undefined ? obj[keyPart] : null), item);
  }

  // Cerca il termine in tutte le proprietà di un oggetto
  private containsTermInObject(obj: any, term: string): boolean {
    return Object.keys(obj).some((key) => {
      const value = obj[key];
      return typeof value === 'string' && value.toLowerCase().includes(term);
    });
  }
}
